import { ActivityStep } from './types';
import SectionHeader from './SectionHeader';
import StepItem from './StepItem';

interface ActivityStepsProps {
  steps: ActivityStep[];
}

/**
 * ActivitySteps Component
 * 
 * "Try this" section with numbered instruction steps.
 * Responsive: Padding scales with container.
 */
export default function ActivitySteps({ steps }: ActivityStepsProps) {
  return (
    <div style={{ marginTop: '24px' }}>
      <SectionHeader title="Try this" />
      
      <div 
        className="flex flex-col gap-2 mt-6 px-6 sm:px-8 md:px-10 lg:px-12"
      >
        {steps.map((step) => (
          <StepItem key={step.id} step={step} />
        ))}
      </div>
    </div>
  );
}
